import * as Sentry from '@sentry/browser';
import { auth } from '../firebase/init.js';

export async function getAuthHeaders() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    if (!auth.currentUser) {
        Sentry.addBreadcrumb({
            category: 'auth',
            message: 'No authenticated user when building auth headers',
            level: 'warning',
        });
        return headers;
    }

    try {
        const token = await auth.currentUser.getIdToken();
        if (token) {
            headers['Firebase-Token'] = `Bearer ${token}`;
        }
    } catch (err) {
        Sentry.addBreadcrumb({
            category: 'auth',
            message: 'Failed to get Firebase ID token',
            level: 'error',
            data: { error: err.message },
        });
    }

    return headers;
}
